export default "__VITE_ASSET__BDbn81Cd__"